import { render } from "./SystemSettingsPage.vue?vue&type=template&id=8505c35a"
import script from "./SystemSettingsPage.vue?vue&type=script&lang=js"
export * from "./SystemSettingsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__